import type { UiTypes } from "various-ui";

export const useOptions = () => {
    //* 插件
    const i18n = useI18n();

    return {
        tissue: <UiTypes.candidate[]>[
            { value: "group", label: i18n.t("Module6Selector1") },
            { value: "mean_base", label: i18n.t("Module6Selector2") },
            { value: "sample", label: i18n.t("Module6Selector3") },
        ],
        cell: <UiTypes.candidate[]>[
            { value: "group", label: i18n.t("Module6Selector4") },
            { value: "nTPM", label: i18n.t("Module6Selector2") },
            { value: "organ", label: i18n.t("Module6Selector3") },
        ],
    };
};
